/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Info_OrganizersInputs */



/**
* | output |
* | --- |
* | "Organizers" |
*
* @param {Tournament_Info_OrganizersInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_info_organizers = /** @type {((inputs?: Tournament_Info_OrganizersInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Info_OrganizersInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Organisateurs")
	if (locale === "es") return /** @type {LocalizedString} */ ("Organizadores")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Organizadores")
	if (locale === "it") return /** @type {LocalizedString} */ ("Organizzatori")
	return /** @type {LocalizedString} */ ("Organizers")
});